export default __webpack_public_path__ + "static/media/p31.7f34d9a5.svg";